import React, { useState } from "react";
import Swal from "sweetalert2";
import { submitPartnerNotification } from "../../../../api/Api";
import { getFromLocalStorage } from "../../../../utils/common-utils";
import "./partnerNotificationTabs.css";
import Loader from "../../../../components/loader/loader";

export default function PartnerNotificationTabs({
  productId,
  setActiveTab,
  serviceId,
  onComplete
}) {
  const [notificationData, setNotificationData] = useState({
    notifyUrl: "",
    lpUrl: "",
  });
  const [isLoading, setIsLoading] = React.useState(false);    

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const payload = {
        id: productId,
        userId: getFromLocalStorage("userData")?.id,
        serviceId: serviceId,
        notifyUrl: notificationData.notifyUrl,
        lpUrl: notificationData.lpUrl,
      };

      const response = await submitPartnerNotification(payload);

      if (response?.statusDescription?.status === 200) {
        Swal.fire({
          icon: "success",
          text:
            response?.statusDescription?.description ||
            "Partner notification details saved successfully!",
        }).then(() => {
          onComplete();
          setActiveTab("customerNotification");
        });
      } else {
        Swal.fire({
          icon: "error",
          text:
            response?.statusDescription?.description ||
            "Failed to save partner notification details",
        });
      }
    } catch (error) {
      console.error("Error submitting partner notification details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to save partner notification details",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="tab-pane active">
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Notify Url</label>
              <input
                type="text"
                className="form-control"
                name="notifyUrl"
                value={notificationData.notifyUrl}
                onChange={handleChange}
                placeholder="Enter Notify Url"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Landing Page Url</label>
              <input
                type="text"
                className="form-control"
                name="lpUrl"
                value={notificationData.lpUrl}
                onChange={handleChange}
                placeholder="Enter LP Url"
              />
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-12 text-right d-flex justify-content-between buttons_divs">
            <div>
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => setActiveTab("sms")}
              >
                Previous
              </button>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                Save & Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
